import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/vi";
import utc from "dayjs/plugin/utc";
import { Lang } from "localization/lang";
import { ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";
dayjs.extend(utc);
type DateTimeProviderProps = {
  children: ReactNode;
};
export const DateTimeProvider = ({ children }: DateTimeProviderProps) => {
  const { i18n } = useTranslation();

  const locale = useMemo(() => {
    if (i18n.language === Lang.viVN) {
      dayjs.locale("vi");
      return "vi";
    }
    dayjs.locale("en");
    return "en";
  }, [i18n.language]);
  return (
    <LocalizationProvider adapterLocale={locale} dateAdapter={AdapterDayjs}>
      {children}
    </LocalizationProvider>
  );
};
